<template>
  <div class="repor" v-if="dataPermission && dataPermission.includes('CNPS_SUMMARY_REPORT_XLS')">
    <div class="breadcrumb-area pos-relative">
      <h1>Báo cáo thống kê tổng hợp công việc của CVKD</h1>
    </div>
    <!-- End Breadcrumb Area -->
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search">
          <div class="form-group">
            <label>Thời gian báo cáo</label>
            <DateRangePicker
              :ranges="false"
              class="w-100"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label style="min-width: 13.5em" class="text-center">
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
              </template>
              <!--Optional scope for the input displaying the dates -->
            </DateRangePicker>
          </div>
          <div class="form-group">
            <label for>Vùng</label>
            <Select2
              v-model="search.regionId"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
            />
          </div>
          <div class="form-group">
            <label for>Tỉnh / thành phố</label>
            <Select2 v-model="search.cityCode" :options="dataProvince" />
          </div>
        </form>
        <div class="box-search d-inline-block m-t-23">
          <button
            :disabled="loading"
            @click="exportExcel()"
            type="button"
            class="btn btn-info hc-37 mr-2 m-b-10 pt-2 file-input"
            data-toggle="tooltip"
            data-placement="top"
            title="Xuất Excel"
            v-if="dataPermission && dataPermission.includes('CNPS_SUMMARY_REPORT_XLS')"
          >
            <i class="bx bx-download"></i>
            <span class="ml-1"></span>Xuất Excel
          </button>
        </div>
        <!-- <div v-if="loading">
          <div colspan="12" class="text-center">
            <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
          </div>
        </div> -->
      </div>
    </div>

    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>

    <NotiSuccess
      :showModalSuccess="showModalSuccess"
      :messSuccess="messNoti"
      @close="showModalSuccess = false"
    >
    </NotiSuccess>

    <NotiError :showModalErr="showModalErr" :messErr="messNoti" @close="showModalErr = false">
    </NotiError>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import { CalendarService } from '@/services/calendar.service'
  import moment from 'moment'

  export default {
    data() {
      return {
        dataRole: [],
        search: {},
        localeData: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' - ',
          applyLabel: 'Áp dụng',
          cancelLabel: 'Hủy bỏ',
          weekLabel: 'W',
          daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
          monthNames: [
            'Tháng 1',
            'Tháng 2',
            'Tháng 3',
            'Tháng 4',
            'Tháng 5',
            'Tháng 6',
            'Tháng 7',
            'Tháng 8',
            'Tháng 9',
            'Tháng 10',
            'Tháng 11',
            'Tháng 12',
          ],
          firstDay: 0,
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dataConfigRegion: [],
        dataProvince: [],
        loading: false,
        showModalSuccess: false,
        showModalErr: false,
        messNoti: null,
      }
    },

    created() {
      this.getRegions()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      async getRegions() {
        const dataRes = await StaffService.getRegions()
        if (dataRes.data.length > 0) {
          const dataRegion = []
          dataRes.data.map(e => {
            dataRegion.push({ id: e.id, text: e.name })
          })
          this.dataConfigRegion = dataRegion
        }
      },

      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            const dataProvince = []
            data.data.map(e => {
              const body = {
                id: e.code,
                text: e.name,
              }
              dataProvince.push(body)
            })
            this.dataProvince = dataProvince
          } else {
            this.dataProvince = []
          }
        } catch (error) {
          console.log(error)
        }
      },

      async exportExcel() {
        try {
          this.loading = true
          this.search.startDate = moment(this.dateRange.startDate).startOf('day').valueOf()
          this.search.endDate = moment(this.dateRange.endDate).endOf('day').valueOf()
          await CalendarService.exportExcelCVKD(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped></style>
